import navbar from "./navbar.module.css"
import zee_logo from "../../assets/zee_logo.png"
import { useNavigate } from "react-router-dom"
export default function Navbar () {
    const nav = useNavigate()
    return <div className={navbar.navbar}>
        <div onClick={() => nav("/")}>
            <img src={zee_logo} alt="" />
        </div>
    </div>
}